import createSelector from 'selectorator';

import type { ReduxStore } from '../store';

import type { NavigationState } from './types';

const NavigationSelectors = {
  get: createSelector<ReduxStore, NavigationState>(['navigation']),
};

export default NavigationSelectors;
